import { useContext } from 'react'
import I18nProvider, { TranslationContext } from './i18nProvider'

export { I18nProvider }

export function useTranslation() {
  return useContext(TranslationContext)
}
